var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.2,
    height: 16,
    viewBox: "0 0 15.2 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12836",
    "data-name": "Group 12836",
    transform: "translate(-22.529 -5.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10321",
    "data-name": "Path 10321",
    d: "M140.633,52.5a.673.673,0,0,0-.448.166.538.538,0,0,0-.185.4v13.6a.538.538,0,0,0,.185.4.673.673,0,0,0,.448.166h4.433a.674.674,0,0,0,.454-.163.526.526,0,0,0,0-.807.674.674,0,0,0-.454-.163h-3.8V55.9h12.666V66.1h-3.8a.675.675,0,0,0-.454.163.526.526,0,0,0,0,.807.675.675,0,0,0,.454.163h4.433a.673.673,0,0,0,.448-.166.538.538,0,0,0,.185-.4v-13.6a.538.538,0,0,0-.185-.4.673.673,0,0,0-.448-.166Z",
    transform: "translate(-117.471 -47.088)",
    fill: "#0376a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10322",
    "data-name": "Path 10322",
    d: "M256.852,227.494a.562.562,0,0,0-.466.225l-2.531,3.375a.563.563,0,0,0,.45.9h1.969v3.93a.562.562,0,1,0,1.125,0v-3.93h1.97a.563.563,0,0,0,.449-.9l-2.531-3.375h0a.563.563,0,0,0-.435-.225Z",
    transform: "translate(-226.65 -215.081)",
    fill: "#0376a8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.39b109d6c795f77ae847355004b93663.svg";
export { ForwardRef as ReactComponent };